import React from "react";
import { ReactComponent as GITHUB_WORK_LINK } from "../img/work-link_icons/github.svg";

export const GitHubWorkLink = () => {
  return <GITHUB_WORK_LINK title="github repo" />;
};
